export default __webpack_public_path__ + "static/media/exclamation-mark.59a8d2ea.svg";